import { render, staticRenderFns } from "./PivotProp.vue?vue&type=template&id=794596ad&"
import script from "./PivotProp.vue?vue&type=script&lang=js&"
export * from "./PivotProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports